import React from 'react';
import styles from './CategoryProgressBar.module.css';
import {CategoryArray, CategorySegment, makeCategorySegments} from 'screens/InsomniaSurvey/utils/categoryUtils';

interface Props {
  pageNumber: number;
  categories: CategoryArray;
}

export function getPctOfSegmentComplete(pageNumber: number, segment: CategorySegment) {
  const pos = pageNumber - segment.start;
  const total = segment.end - segment.start + 1;
  return Math.max(0, Math.min(1, pos / total));
}
const Checkmark: React.FC<{className: string}> = ({className}) => {
  return (
    <svg
      className={className}
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.25 9L9 12L15 5.5" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export const CategoryProgressBar: React.FC<Props> = ({pageNumber, categories}) => {
  const segments = makeCategorySegments(categories);

  return (
    <div data-testid="category-progress-bar" className={`${styles.container}`}>
      {segments.map((s, i) => {
        const pctComplete = pageNumber <= s.end ? getPctOfSegmentComplete(pageNumber, s) : 1;
        const firstSegment = i === 0;
        const lastSegment = i === segments.length - 1;
        const segmentBorderRadius = firstSegment ? styles.firstSegment : lastSegment ? styles.lastSegment : '';
        return (
          <div key={`${s.value}-${i}`} className={styles.segmentContainer}>
            <div className={`${styles.segment} ${segmentBorderRadius}`}>
              <div className={styles.segmentHighlight} style={{width: `${pctComplete * 100}%`}} />
            </div>

            {!lastSegment ? (
              pctComplete === 1 ? (
                <Checkmark className={styles.checkmark} />
              ) : (
                <div className={styles.segmentPip} />
              )
            ) : null}
          </div>
        );
      })}
    </div>
  );
};
